<template>
    <div class="elle-news-grid padd-v-top">
        <div ref="$grid" class="elle-news-grid--grid">
            <CardsPost v-for="post in posts" :key="post.id" :post="post" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const emit = defineEmits(['onEndScroll']);

const props = withDefaults(
    defineProps<{
        posts?: CmsItem[];
    }>(),
    {
        posts: () => []
    }
);

const { $ScrollTrigger: ScrollTriger } = useNuxtApp();
const posts = computed(() => props.posts);
const $grid = ref<HTMLDivElement | null>(null);

onMounted(() => {
    if (!$grid.value) return;

    ScrollTriger.create({
        trigger: $grid.value,
        start: 'top top',
        end: '80%',
        markers: false,
        onLeave: () => {
            emit('onEndScroll', true);
        }
    });
});
</script>
